<template>
  <div class="group-comment-sidebar">
    <b-sidebar
      position="absolute"
      :right="true"
      :fullheight="true"
      :overlay="false"
      :open="isOpenSalary"
      @close="sidebarCancel"
    >
      <div>
        <b-input v-model="searchInput" placeholder="Søg på Salary Type" class="search-bar"></b-input>

        <div>
          <b-button @click="deSelectAll" class="table-related-button button" v-if="anySelected">
            Fravælg alle
          </b-button>
        </div>
        <div>
          <b-button @click="selectAll" class="table-related-button button" v-if="anyDeSelected">
            Vælg alle
          </b-button>
        </div>

        <b-table v-if="filtered !== undefined" class="sidebar-table table" :data="filtered" hoverable>
          <b-table-column field="name" label="Navn" v-slot="props">
            {{ props.row.reportRowName }}
          </b-table-column>

          <b-table-column field="isSelected" label="Valgt" v-slot="props">
            <b-field>
              <b-checkbox v-model="props.row.isSelected"></b-checkbox>
            </b-field>
          </b-table-column>
        </b-table>

        <button @click="cancel" class="acceptance-button button is-primary">Anuller</button>
        <button @click="update" class="acceptance-button button is-primary">Vis</button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from '../../enums/APISTATE';

export default {
  name: "salary-type-filter-sidebar",
  props: {},
  data: () => ({
    searchInput: "",
    displayedSalaryTypes: []
  }),
  mounted() {
    this.displayedSalaryTypes = this.salaryTypeGroup
  },
  computed: {
    ...mapGetters("salaryTypeFilteringSidebar", [
      "isOpenSalary",
      "salaryTypeGroup"
    ]),
    filtered(){
      if(!this.searchInput) {
        return this.displayedSalaryTypes
      }

      return this.displayedSalaryTypes.filter(o => o.reportRowName.toLowerCase().includes(this.searchInput.toLowerCase()))
    },
    anySelected() {
      if(!this.displayedSalaryTypes) {
        return false
      }
      return this.displayedSalaryTypes.filter(o => o.isSelected).length > 0
    },
    anyDeSelected() {
      if(!this.displayedSalaryTypes) {
        return false
      }
      return this.displayedSalaryTypes.filter(o => o.isSelected == false).length > 0
    }
  },
  methods: {
    ...mapActions("salaryTypeFilteringSidebar", [
      "sidebarCancel",
      "updateParentView",
      "setSalaryTypes"
    ]),
    deSelectAll(){
      this.displayedSalaryTypes.forEach((agm) => {
        if (agm.isSelected) {
          agm.isSelected = false;
        }						
      });
    },
    selectAll(){
      this.displayedSalaryTypes.forEach((agm) => {
        if (!agm.isSelected) {
          agm.isSelected = true;
        }						
      });
    },
    update() {
      this.searchInput = "";
      this.setSalaryTypes(this.displayedSalaryTypes) // Save back
      this.updateParentView()
    },
    cancel() {
      this.searchInput = "";
      this.sidebarCancel();
    }
  },
  watch: {
    'salaryTypeGroup'(newValue){
      console.log('watch: salaryTypeGroup....')
      this.displayedSalaryTypes = newValue
    }
  }
};
</script>

<style lang="scss">
.search-button{
  margin-bottom:15px;
}
.sidebar-table {
margin:35px 15px 15px 15px;
}
.table-related-button {
  float:right; 
  margin-right:15px;
}
.search-bar {
  margin: 10px 50px 10px 50px;
}
.acceptance-button {
  margin:7px 10px 7px 10px;
}
</style>